module.exports = __webpack_public_path__ + "static/media/product_3.fa4cf6eb.png";